/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Grid, Box, Typography, Card, Button } from '@mui/material';
import { Container } from '@mui/system';
import { makeStyles } from '@mui/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Helmet } from 'react-helmet-async';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import lottie from 'lottie-web';
import CancelIconPay from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckMark from '../../assets/lottie/checkMark.json';
import CancelIcon from '../../assets/lottie/cancel-animation.json';
import subscriptionServices from '../../services/subscriptionServices';
import courseApi from '../../services/users/courseApi';
import loginServices from '../../services/loginServices';
import identifyPosthogUser from '../../utils/posthogIdentify';
import { setSubscribedCourses, loginSuccess} from '../../store/reducer';
import {getOfferbaner, getLernerView, getAssessmentList, getCognitiveAssessment, getNEETAssessment, getSubscribedAssessment, getSatDetails, getRecomdedCourseList, getBundleCourses1,getDynamicCourseDetails, getCategoryDetails, getCertificateList, getAllFreeCourses, getAllcourseDetails} from '../../Redux/Action';

export const SuccessPage = () => {
  const classes = useStyles();
  const lottoLoad = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [courseDetails, setCourseDetails] = useState(null);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const planId = query.get('planId');
  const canceled = query.get('canceled');
  const success = query.get('success');
  const userid = useSelector((state) => state.userInfo && state.userInfo.id);
  const { userInfo } = useSelector((state) => state);
  const allcourseDetails = useSelector((state) => state);
  const allSatDetails = useSelector((state) => state.GetSatDetails);
  const [allApisLoaded, setAllApisLoaded] = useState(false);

  const getCourserList = async () => {
    try {
      const response = await courseApi.getCourseList();
      if (response.ok) {
        dispatch(setSubscribedCourses(response.data));
      } else {
        console.log('failed');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCourseDetails = async () => {
    try {
      const res = await subscriptionServices.getSubscriptionDetailsByPlanId(planId, userid);
      if (res.ok) {
        setCourseDetails(res.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const loadAllData = async () => {
      try {
        await Promise.all([
          dispatch(getSatDetails(userid)),
          dispatch(getOfferbaner()),
          dispatch(getLernerView('en')),
          dispatch(getAssessmentList(userid)),
          dispatch(getCognitiveAssessment(userid)),
          dispatch(getNEETAssessment(userid)),
          dispatch(getSubscribedAssessment(userid)),
          dispatch(getRecomdedCourseList(userid, 'en')),
          dispatch(getBundleCourses1(1, 'en')),
          dispatch(getDynamicCourseDetails('en', userid)),
          dispatch(getCategoryDetails()),
          dispatch(getCertificateList('en')),
          dispatch(getAllFreeCourses('en', userid)),
          dispatch(getAllcourseDetails('en')),
        ]);
      } catch (err) {
        console.log('Some dispatches failed:', err);
      } finally {
        setAllApisLoaded(true);
      }
    };

    loadAllData();
  }, []);

  const getLoginUserDetails = async () => {
    const res = await loginServices.getUserInfo();
    if (res.ok) {
      dispatch(loginSuccess(res.data));
      identifyPosthogUser(res.data);
    }
  };

  useEffect(() => {
    if (success === 'true') {
      getCourserList();
      if (userInfo?.currencyType === null) {
        getLoginUserDetails();
      }
    }
  }, [success]);

  useEffect(() => {
    getCourseDetails();
    if (canceled === 'true') {
      lottie.loadAnimation({
        container: lottoLoad.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: CancelIcon,
      });
    } else {
      lottie.loadAnimation({
        container: lottoLoad.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: CheckMark,
      });
    }
  }, [planId]);

  
  const handleCardClickItem = (data, type) => {

    if (data?.contentType !== 'Course' && type === "Back") {
      navigate('/auth/plans', {
        state: { satDetails: allSatDetails }
      });
      return;
    }
    if (data?.assessment_type === null && data?.contentType === null) {
      navigate('/auth/subscribe');
      return;
    }
    const updatedCourseDetails = {
      ...data,
      ispaid: type === "Back" ? false : data?.ispaid,
    };
    if (updatedCourseDetails?.subscriptionName && ["professional plan", "premium plan", "basic plan"].some(plan => updatedCourseDetails.subscriptionName.toLowerCase().includes(plan))) {
      navigate('/auth/subscribe');
      return;
    }


    if (allcourseDetails?.BundleDetails && data?.subscriptionName) {

      const matchedBundle = allcourseDetails.BundleDetails.find(
        (bundle) => bundle?.subscriptionPlanName === data?.subscriptionName
      );

      // if (matchedBundle) {
      //   navigate("/auth/bundledetails", { state: { item: matchedBundle } });
      //   return;
      // }
      if (matchedBundle) {
        navigate("/auth/bundledetails", {
          state: {
            item: matchedBundle,
            comingFrom: "bundleList" 
          }
        });
        return;
      }
      navigate(`/auth/course-details/${updatedCourseDetails?.id}/${updatedCourseDetails?.subscriptionPlanId || updatedCourseDetails?.subscriptionplanid || ""}`, { state: updatedCourseDetails });
      return;
    }


    navigate(`/auth/course-details/${updatedCourseDetails?.id}/${updatedCourseDetails?.subscriptionPlanId || updatedCourseDetails?.subscriptionplanid || ""}`, { state: updatedCourseDetails });
  };

  const startButtonLabel = () => {
    if (!courseDetails?.contentId && !courseDetails?.subscriptionPlanId) return 'Loading...';
    if (!allApisLoaded) return 'Loading...';
    return 'Start Learning';
  };

  return (
    <>
      {!canceled && (
        <Helmet>
          <script>
            {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '228066771624385');
            fbq('track', 'PageView');
              fbq('track', 'Purchase', {
          value: '19.99',
          currency: 'USD',
          content_ids: 'PythonBeginnerMonthlyPlan',
          content_type: 'Subscription',
        });
            `}
          </script>
        </Helmet>
      )}
      <div>
        <div className={classes.outlook}>
          <Container sx={{ maxWidth: '1000px ! important', maxHeight: '400px ! important', minHeight: '400px ! important' }}>
            <Grid container sx={{ maxWidth: '1000px ! important', maxHeight: '400px ! important', minHeight: '400px ! important' }}>
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Card className={classes.card} sx={{ padding: '31px' }}>
                  <div>
                    <Box
                      sx={{
                        margin: '0rem',
                        borderRadius: '8px',
                        // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 100%',
                        width: '100%',
                        height: '20px',
                      }}
                    />
                  </div>
                  <div className={classes.design}>
                    <div className={classes.list} style={{ display: 'inline' }}>
                      {canceled === 'true' ? (
                        <CancelIconPay fontSize="large" style={{ color: '#ff3333' }} />
                      ) : (
                        <CheckCircleIcon fontSize="large" style={{ color: '#2ec444' }} />
                      )}
                      <Typography className={classes.listItem} style={{ marginTop: '10px' }} gutterBottom>
                        {canceled === 'true' ? (
                          <>
                            <span style={{ fontWeight: 'bold' }}>Payment Unsuccessful</span>
                            <Typography
                              variant="body2"
                              sx={{
                                marginTop: '10px',
                                marginBottom: '20px',
                                color: '#666',
                                lineHeight: 1.6
                              }}
                            >
                              Sorry, your payment failed or your attempt to purchase our subscription failed! We suggest retrying the payment from the starting point and not from this page.
                            </Typography> </>
                        ) : (
                          <>
                            <span style={{ fontWeight: 'bold' }}>Thank you for your purchase</span>
                            <Typography
                              variant="body2"
                              sx={{
                                marginTop: '10px',
                                marginBottom: '20px',
                                color: '#666',
                                lineHeight: 1.6
                              }}
                            >
                              Happy learning! You will receive an email about your purchase shortly. If you have any concerns, send an email to{' '}
                              <a
                                href="mailto:contact@keyskillset.com"
                                style={{ color: '#1976d2', textDecoration: 'none' }}
                              >
                                contact@keyskillset.com
                              </a>
                            </Typography>

                          </>
                        )}
                      </Typography>

                    </div>
                    <Box sx={{ margin: '40px 0px 0px 0rem' }}>
                      {canceled === 'true' ? (
                        <div>
                          <LoadingButton
                            startIcon={(courseDetails?.contentId || courseDetails?.subscriptionPlanId) ? <ArrowBackIcon /> : ""}
                            variant={(courseDetails?.contentId || courseDetails?.subscriptionPlanId) ? "outlined" : "contained"}
                            color={(courseDetails?.contentId || courseDetails?.subscriptionPlanId) ? "inherit" : "primary"}
                            disabled={!(courseDetails?.contentId || courseDetails?.subscriptionPlanId)}
                            sx={
                              (courseDetails?.contentId || courseDetails?.subscriptionPlanId)
                                ? {
                                  borderRadius: "8px",
                                  padding: "6px 16px",
                                  borderColor: "#ccc",
                                  color: "#444",
                                  backgroundColor: "transparent",
                                  "&:hover": {
                                    borderColor: "#999",
                                    backgroundColor: "#f5f5f5",
                                  },
                                }
                                : {}
                            }
                            onClick={() => handleCardClickItem(courseDetails, "Back")}
                          >
                            {(courseDetails?.contentId || courseDetails?.subscriptionPlanId) ? "Go Back" : "loading..."}
                          </LoadingButton>

                        </div>
                      ) : (
                        <Button
                          variant="outlined"
                          color="primary"
                          disabled={!(courseDetails?.contentId || courseDetails?.subscriptionPlanId) || !allApisLoaded}
                          onClick={() => handleCardClickItem(courseDetails, "Start")}
                          title="Start Learning"
                          sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            px: 3,
                            py: 1,
                            fontWeight: 500,
                            borderColor: "#ccc",
                            color: "#444",
                            backgroundColor: "transparent",
                            "&:hover": {
                              borderColor: "#999",
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          {startButtonLabel()}
                        </Button>
                      )}
                    </Box>
                  </div>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </div>
        {/* </WebPage> */}
      </div>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  listItem: {
    // color: '#27292E',
    fontSize: '18px',
    fontWeight: '400',
    // marginLeft: '12px',
    textAlign: 'center',
    margin: '0rem ',
  },
  list: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '1.6rem 0rem 0rem 0rem',
  },
  design: {
    // marginTop: '30px',
    // display: 'flex',
    textAlign: 'center',
  },
  card: {
    width: '95%',
    height: '80%',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      width: '55%',
    },
  },
  name: {
    color: '#00B673',
    fontWeight: '500',
    marginBottom: '10px',
  },
  font: {
    color: '#101828',
    fontSize: '1.4rem',
    fontWeight: '600',
    lineHeight: '30px',
    marginBottom: '10px',
    '@media (max-width: 640px)': {
      fontSize: '1.2rem',
    },
  },
  title: {
    textAlign: 'center',
    margin: '1rem',
  },
  titleName: {
    textAlign: 'center',
    margin: '1rem',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  outlook: {
    padding: '32px 23px 0px 23px',
    marginTop: ' 5rem',
    '@media (max-width: 780px)': {
      padding: '32px 0px 16px 0px',
    },
  },
}));